<template>
    <h1 class="mt-5"><b>404</b></h1>
    <h1><em>{{ msg }}</em></h1>
</template>

<script>
export default {
    name: 'page404',
    data() {
        return {
            msg: 'Page not Found'
        }
    }
}
</script>

